module.exports = __webpack_public_path__ + "media/applicants/full-service-shopper-19a5922a.jpg";